module.exports = "<uib-tabset active=\"$ctrl.active\" justified=\"$ctrl.justified\" type=\"{{$ctrl.type}}\" vertical=\"$ctrl.vertical\">\r\n    <uib-tab index=\"$index\" ng-repeat=\"tab in $ctrl.tabs\" heading=\"{{tab.title}}\">\r\n        <div bind-dynamic-page=\"tab.content\"></div>\r\n    </uib-tab>\r\n</uib-tabset>"


//////////////////
// WEBPACK FOOTER
// ./client/components/tabs-widget/tabs-widget.component.html
// module id = 628
// module chunks = 0